export const offerTabsCategories = {
  items: [
    { title: 'Все', prefix: 'all', id: 0 },
    // { title: 'х2 монет', prefix: 'double', id: 1 },
    { title: 'Мои', prefix: 'my', id: 2 },
    // { title: 'Dating', prefix: 'dating', id: 6 },
    // { title: 'TP', id: 10 },

    // { title: 'Эксклюзивы', prefix: 'exclusive', id: 3 },
    // { title: 'Бурж COD', prefix: 'external', id: 4 },
    // { title: 'Гемблинг', prefix: 'gambling', id: 5 },

    // { title: 'SP', prefix: 'sp', id: 7 },
    // { title: 'WillSkill', prefix: 'ws', id: 8 },
    // { title: 'Tutor Place', prefix: 'tp', id: 9 },
    // { title: 'Skill Deposit', prefix: 'sd', id: 10 },
  ],
};
